import React, { Component } from 'react'
import Spinner from 'react-bootstrap/Spinner'

export class Loading extends Component {
    render() {
        return (
            <div className="loading-div">
            <Spinner
              as="div"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
            />
            Loading...
          </div>
        )
    }
}

export default Loading
